export default {
    'report.invoice.form.reportType': 'Select the Report Type',
    'report.invoice.form.reportType.analytical': 'Analytical',
    'report.invoice.form.reportType.synthetic': 'Synthetic',
    'report.invoice.form.reportType.byPieces': 'By Pieces',
    'report.invoice.form.reportType.perInvoice': 'Per Invoice',
    'report.invoice.form.selection.cstpis/cofins': 'CST PIS/COFINS',
  };
  